const AWS = require('aws-sdk/global');
export const getAuthCredentials = () => {
  const params = {
    IdentityPoolId: process.env.REACT_APP_CCPA_IDENTITY_POOL_ID
  };

  AWS.config.region = process.env.REACT_APP_AWS_REGION;

  AWS.config.credentials = new AWS.CognitoIdentityCredentials(params);
  let cognitoidentity = new AWS.CognitoIdentity();

  AWS.config.credentials.expiryWindow = 15;

  return new Promise((resolve, reject) => {
    AWS.config.credentials.get((err) => {
      if (err) {
        reject(err);
      }

      let params = {
        IdentityId: AWS.config.credentials.identityId /* required */
      };
      // after identity from the pool, get credentials for the identity
      cognitoidentity.getCredentialsForIdentity(params, function (
        err,
        data
      ) {
        if (err) {
          // an error occurred
        } else {
          // successful response to get AccessKeyId and SecretKey
          const token = {
            accessKeyId: data.Credentials.AccessKeyId,
            secretAccessKey: data.Credentials.SecretKey,
            sessionToken: data.Credentials.SessionToken
          };
          resolve(token);
        }
      });
    });
  })
};